import React from "react";

import styled from "styled-components";

import Icon from '../assets/svg/Anvil-2.svg';

import { scrollTo } from 'scroll-js';


import Theme from "../utils/theme";


const cream = Theme.Colors.cream;

class GlobalNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reveal: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleIconClick() {
    scrollTo(document.body, { top: 0, easing: 'ease-in-out', duration: 1000 });
  }

  handleScroll = () => {
    const height = window.innerHeight;
    const scroll = document.body.scrollTop || document.documentElement.scrollTop;
    
    if (scroll > height + (height * .05)) {
      this.setState({reveal: true});
    } else {
      this.setState({reveal: false});
    }
  }

  render() {
    return (
        <Navigation className={this.state.reveal && 'reveal'}>
          <button onClick={this.handleIconClick}>
            <Icon/>
          </button>
          <NavList>

          </NavList>
        </Navigation>
    );
  }
}

const Navigation = styled.nav`
    width: 100%;
    background-color: ${cream};
    height: 50px;
    position: fixed;
    z-index: 10;
    top: 0px;
    left: 0px;
    transition: all 0.25s ease-in-out;
    transform: translateY(-100%);
    display: flex;
    button {
      background-color: transparent;
      cursor: pointer;
      transform: translateX(-100%);
      transition: all 0.4s ease-in-out 0.25s;
    }
    &.reveal {
      transform: translateY(0%);
      box-shadow: 0px 0px 25px rgba(0,0,0, 0.15);
      transform: translateY(0%);
      button {
        transform: translateX(0%);
      }
    }
    svg {
      width: 6em;
      height: 5em;
      fill: ${Theme.Colors.blue};
      align-self: flex-start;
      margin-left: -0.75em;
      margin-top: -0.5em;
    }
    @media all and (min-width: 50em) {
      svg {
        margin-left: 1em;
      }
    }
`;

const NavList = styled.ul`


`;


export default GlobalNavigation;
